var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container modal-child" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "div",
          { staticClass: "md-layout-item" },
          [
            _c(
              "md-datepicker",
              {
                ref: "mdDatePicker",
                staticClass: "date-clone-filter",
                attrs: { "md-immediately": "", "md-debounce": 10 },
                model: {
                  value: _vm.tripDate,
                  callback: function ($$v) {
                    _vm.tripDate = $$v
                  },
                  expression: "tripDate",
                },
              },
              [_c("label", [_vm._v("Trip Date")])]
            ),
          ],
          1
        ),
        _c("md-field", { staticClass: "driver-clone-filter" }, [
          _c(
            "div",
            { staticClass: "driver-icon md-just-icon md-round" },
            [_c("md-icon", [_vm._v("account_circle")])],
            1
          ),
          _c(
            "div",
            { staticClass: "driver-clone-filter" },
            [
              _c("vue-select", {
                staticClass: "driver-filter",
                attrs: {
                  reduce: function (fullName) {
                    return fullName.userId
                  },
                  label: "fullName",
                  options: _vm.filteredTeamMemberList,
                  placeholder: "Team Member",
                  searchable: _vm.$root.isDesktop,
                },
                model: {
                  value: _vm.teamMemberFilterValue,
                  callback: function ($$v) {
                    _vm.teamMemberFilterValue = _vm._n($$v)
                  },
                  expression: "teamMemberFilterValue",
                },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default confirm-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary confirm-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.confirm($event)
              },
            },
          },
          [_vm._v("Confirm")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Duplicate Details")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }